import { useFormProps } from '@/features/form';
import HandleTabIndex from './HandleTabIndex';

export default function MatrixLikert({
	children,
	block,
	state,
	setNestedValue,
	...props
}) {
	const { elements, values, weights } = block.properties;

	const { isMultiple, multipleIndex } = useFormProps();

	return (
		<table
			class={`table table-striped ${block.typeName}-table`}
			role="radiogroup"
			{...(block.properties.required && { 'aria-required': true })}
			aria-labelledby={`block-title-${block.typeName}-${block.id}`}
		>
			<thead>
				<tr>
					<th
						class={`${block.typeName}-subject-label`}
						aria-hidden="true"
					></th>
					{Object.keys(values).map(key => {
						return (
							<th class={`${block.typeName}-answer-label`}>
								<div>
									<span>{values[key].label}</span>
								</div>
							</th>
						);
					})}
					{weights && (
						<th
							class={`${block.typeName}-spacer`}
							aria-hidden="true"
						></th>
					)}
					{weights &&
						Object.keys(weights).map(key => {
							return (
								<th class={`${block.typeName}-answer-label`}>
									<div>
										<span>{weights[key].label}</span>
									</div>
								</th>
							);
						})}
				</tr>
			</thead>
			<tbody>
				{Object.keys(elements).map((key, i) => {
					const id = `${block.typeName}_${block.id}_${i + 1}`;
					const element = elements[key];
					return (
						<tr>
							<td class={`${block.typeName}-subject`}>{elements[key].label}</td>
							{Object.keys(values).map((vKey, vI) => {
								const valueDataField =
									block.typeName === 'matrix'
										? element.data_field?.value
										: element.data_field;

								const valueElement = values[vKey];
								const value = valueElement.value ?? valueElement.label;

								return (
									<td
										class={`${block.typeName}-answer`}
										data-label={values[vKey].label}
									>
										<div class={`${block.typeName}-answer-inner`}>
											<HandleTabIndex
												component="input"
												title={elements[key].label + ', ' + values[vKey].label}
												ariaLabel={elements[key].label + ', ' + values[vKey].label}
												type="radio"
												name={`${id}${block.typeName === 'matrix' ? '_value' : ''}${
													isMultiple ? '_' + multipleIndex : ''
												}`}
												id={`${id}${block.typeName === 'matrix' ? '_value' : ''}_${vI}${
													isMultiple ? '_' + multipleIndex : ''
												}`}
												value={value}
												checked={state[valueDataField].value === value}
												onChange={e => {
													setNestedValue(valueDataField, e.target.value);
												}}
											/>
											<label
												for={`${id}${block.typeName === 'matrix' ? '_value' : ''}_${vI}${
													isMultiple ? '_' + multipleIndex : ''
												}`}
											>
												<span style={{ display: 'none' }}>
													{elements[key].label + ', ' + values[vKey].label}
												</span>
											</label>
										</div>
									</td>
								);
							})}
							{weights && <td class={`${block.typeName}-spacer`}></td>}
							{weights &&
								Object.keys(weights).map((wKey, wI) => {
									const weightDataField =
										block.typeName === 'matrix'
											? element.data_field?.weight
											: element.data_field;
									const weightElement = weights[wKey];
									const value = weightElement.value ?? weightElement.label;

									return (
										<td
											class={`${block.typeName}-answer`}
											data-label={weights[wKey].label}
										>
											<div class={`${block.typeName}-answer-inner`}>
												<HandleTabIndex
													component="input"
													type="radio"
													title={elements[key].label + ', ' + weights[wKey].label}
													ariaLabel={elements[key].label + ', ' + weights[wKey].label}
													name={`${id}_weight${isMultiple ? '_' + multipleIndex : ''}`}
													id={`${id}_weight_${wI}${
														isMultiple ? '_' + multipleIndex : ''
													}`}
													value={
														weights[wKey].value
															? weights[wKey].value
															: weights[wKey].label
													}
													checked={state[weightDataField].value === value}
													onChange={e => {
														setNestedValue(weightDataField, e.target.value);
													}}
												/>
												<label
													for={`${id}_weight_${wI}${
														isMultiple ? '_' + multipleIndex : ''
													}`}
												>
													<span style={{ display: 'none' }}>
														{elements[wKey].label + ', ' + weights[wKey].label}
													</span>
												</label>
											</div>
										</td>
									);
								})}
							<input
								type="hidden"
								id={id}
							/>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
}
